import { Controller } from "@hotwired/stimulus";
import { useListen } from "hb/insights/use_listen";
import DropdownComponentController from "../dropdown_component_controller";

export default class extends Controller {
  connect() {
    useListen(this);

    this.listenWindow("dashboard:openAddWidget", this.show);
  }

  show() {
    DropdownComponentController.for(this.element)?.show();
  }

  handleSelection(event) {
    const { data } = event.detail;
    const widgetData = data.widgetConfig ? JSON.parse(data.widgetConfig) : null;
    this.emitWindow("dashboard:addWidget", widgetData);

    DropdownComponentController.for(this.element)?.hide();
  }
}
